import React from 'react';
import { trans } from '@spotahome/soyuz/client';
import NoSSR from 'react-no-ssr';
import MediaQuery from 'react-responsive';
import { AppBanner as AppBannerComponent } from '@spotahome/ui-library';

import '@spotahome/ui-library/lib/components/AppBanner.css';
import '@spotahome/ui-library/lib/components/Rating.css';
import { MQ_MOBILE_MAX_WIDTH } from '../common/constants';

import './AppBanner.scss';

const AppBanner = () => (
  <NoSSR>
    <MediaQuery maxWidth={MQ_MOBILE_MAX_WIDTH}>
      <div className="app-banner">
        <AppBannerComponent
          title={trans('appbanner.title')}
          text={trans('appbanner.text')}
        />
      </div>
    </MediaQuery>
  </NoSSR>
);

export default AppBanner;
